import { CSSProperties } from "react";
import { Token } from "./cssVars";

/** Padding inside a filters bar. Numeric twin of Token.cardPad. */
export const FILTERS_BAR_PAD = 12;

/**
 * The bar that holds the filters of a list, right above its table: same width, same surface and same
 * radius as the table card, so both read as one stack. Page actions do not live here, they go next to
 * the page title through useToolbarActions.
 */
export const filtersBarStyle = (): CSSProperties => ({
  width: "100%",
  boxSizing: "border-box",
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  alignItems: "center",
  gap: "10px",
  // Units are explicit: MUI reads a bare number in `sx` as spacing units, so `12` would come out as 96px.
  padding: `${FILTERS_BAR_PAD}px`,
  border: `1px solid ${Token.borderDefault}`,
  borderRadius: Token.radiusCard,
  backgroundColor: Token.surfaceCard,
});
